const ANONYMOUS_SESSION_STORAGE_KEY = 'scratch-cloud-anonymous-session-id';

const generateAnonymousSessionId = () => {
    if (typeof globalThis !== 'undefined' && globalThis.crypto && typeof globalThis.crypto.randomUUID === 'function') {
        return `anon-${globalThis.crypto.randomUUID()}`;
    }
    const randomPart = Math.random().toString(36).slice(2, 12);
    return `anon-${Date.now().toString(36)}-${randomPart}`;
};

const getAnonymousSessionId = () => {
    if (typeof window === 'undefined') return '';
    try {
        const existing = window.sessionStorage.getItem(ANONYMOUS_SESSION_STORAGE_KEY);
        if (existing) {
            return existing;
        }
        const generated = generateAnonymousSessionId();
        window.sessionStorage.setItem(ANONYMOUS_SESSION_STORAGE_KEY, generated);
        return generated;
    } catch (e) {
        return '';
    }
};

export default getAnonymousSessionId;
